import React from 'react';
import block from 'bem-cn-lite';

import {ServicePublic} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';

import './ServiceTag.scss';

const b = block('ServiceTag');

//update in cloud schemas
export enum ServiceTagName {
    Free = 'free',
    New = 'new',
    Preview = 'preview',
}

export interface ServiceTagProps extends Pick<ServicePublic, 'status' | 'tag'> {
    className?: string;
    size?: 's' | 'm';
}

const ServiceTag: React.FC<ServiceTagProps> = ({tag, className, size = 'm'}) => {
    if (!tag) {
        return null;
    }

    return <div className={b({size, type: tag}, className)}>{tag}</div>;
};

export default ServiceTag;
